import { Editor } from 'slate';
import { insertLeafDirective } from '../directive/transforms';

export function insertVideo(editor: Editor, url: string) {
    insertLeafDirective(editor, { name: 'video', attributes: { src: url, controls: 'controls' } });
}
